<template>
    <div>
        <!-- In-Progress -->
        <div
            v-if="storedFile.file_processing_status === 'in_progress'"
            class="small text-light-wave ml-1 status-label"
        >
            <info-popover
                content="Optimization can take a few minutes. You can close this edit window and check back later."
                placement="top"
            >
                Optimizing {{ fileTypeName }}...
            </info-popover>
        </div>
        <!-- Optimization Successful -->
        <div
            v-else-if="storedFile.file_processing_status === 'successful'"
            class="small ml-1 status-label"
        >
            <span class="icon icon-glyphicons-basic-circle-check text-success icon-mr"></span>
            <span>{{ fileTypeName }} Optimized</span>
        </div>
        <!-- Optimization Failed -->
        <div
            v-else-if="storedFile.file_processing_status === 'failed'"
            class="small ml-1 mr-2 status-label"
        >
            <span class="icon icon-glyphicons-basic-triangle-alert text-warning icon-mr"></span>
            <span>Optimization Failed</span>
        </div>
        <!-- Start Optimization Button -->
        <button
            v-if="
                storedFile &&
                storedFile.id &&
                ['not_started', 'failed'].includes(storedFile.file_processing_status)
            "
            class="btn btn-sm btn-link p-0 small mr-1"
            @click="initiateElementFileOptimization()"
        >
            <span v-if="storedFile.file_processing_status === 'not_started'">
                <span class="icon icon-glyphicons-basic-magic-wand mr-xs"></span>
                <span>Optimize {{ fileTypeName }}</span>
            </span>
            <span v-else>
                <span class="icon icon-100 icon-glyphicons-basic-refresh mr-xs"></span>
                <span>Retry</span>
            </span>
        </button>
    </div>
</template>

<script>
import http from "@/axios.js"
import InfoPopover from "@/components/InfoPopover"

export default {
    name: "FileProcessingStatus",
    components: {
        InfoPopover,
    },
    props: {
        // The element the stored file is associated with.
        element: {
            type: Object,
            default: function () {
                return {}
            },
        },
        // A name to use to identify the file in labels (e.g. Image, Video).
        fileTypeName: {
            type: String,
            default() {
                return 'File'
            },
            required: false,
        },
    },
    data() {
        return {
            // The stored file itself.
            storedFile: this.element.stored_file,
            // A list of timeout IDs, used to clear out any running timeouts after the
            // component is destroyed.
            statusTimeoutIds: [],
        }
    },
    methods: {
        // Initiate the processing/optimization of the stored file associated with an element.
        initiateElementFileOptimization() {
            this.$set(this.storedFile, "file_processing_status", "in_progress")
            let vm = this
            http.put(`/api/elements/${this.element.id}/process-file/`)
                .then(() => {
                    vm.checkOptimizationStatus(vm.element)
                })
                .catch(() => {
                    vm.storedFile.file_processing_status = "not_started"
                })
        },
        // Check the status of file optimization associated with an element.
        checkOptimizationStatus() {
            let vm = this
            http.get(`/api/elements/${this.element.id}/process-file/`).then((response) => {
                vm.storedFile.file_processing_status = response.data.status
                if (response.data.status == "in_progress") {
                    // File processing is in progress, so check status again in a few
                    // seconds.
                    let timeoutId = window.setTimeout(() => {
                        vm.checkOptimizationStatus(vm.element)
                    }, 3000)
                    vm.statusTimeoutIds.push(timeoutId)
                }
            })
        },
        // Stop all timeouts associated with checking file optimization status.
        clearStatusTimeouts() {
            this.statusTimeoutIds.forEach((timeoutId) => {
                clearTimeout(timeoutId)
            })
        },
        // Clear out any running timeouts when the component is destroyed.
        destroyed() {
            this.clearStatusTimeouts()
        },
    },
}
</script>

<style lang="scss" scoped>
.status-label {
    padding-top: 3px;
    padding-bottom: 3px;
}
</style>